module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row button-placeholder"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('div', {
    staticClass: "pull-left",
    attrs: {
      "id": 'dt-length-' + _vm.getDtId()
    }
  }), _vm._v(" "), _c('form-export', {
    attrs: {
      "active": this.config && this.config.isDumpActionActive,
      "action": _vm.$http.options.root + '/' + this.dumpUrl,
      "filters": this.filters,
      "default-filter": _vm.defaultFilter
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bg price-analysis-dt"
  }, [_c('data-table', {
    attrs: {
      "length-handle": '#dt-length-' + _vm.getDtId(),
      "dt-id": 'data-table-' + _vm.getDtId(),
      "page-length": 10,
      "my-ajax": _vm.dataTableAjax,
      "columns": _vm.columns,
      "column-defs": _vm.columnDefs,
      "refresh": _vm.DTRefresh,
      "sort": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2deba21d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PriceAnalysis/detail.vue
// module id = 1258
// module chunks = 2